
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector, shallowEqual } from 'react-redux';
import PdfJsViewer from './PdfJsViewer';
const PDFViewer = (props) => {
    const token = useSelector(state=> state.auth.token,shallowEqual)
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfBlob, setPdfBlob] = useState(null);
    const iframeRef = useRef();
    const previousUrlRef = useRef(null);

  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const response = await axios.get(`https://portal.ttpadvisory.co.uk:3556/api/get-pdf/${props.filename}`, {
          responseType: 'blob', //  Important to get binary data
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setPdfBlob(response.data);

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        setPdfUrl(objectUrl)
      } catch (err) {
        console.error('Failed to fetch PDF:', err);
      }
    };

    fetchPDF();


  }, [props.filename]);



  return (
    <>
      {pdfUrl ? (                
        <PdfJsViewer pdfBlob={pdfBlob} filename={props.filename} />
      ) : (
        <p>Loading PDF...</p>
      )}
    </>
  )
};

export default PDFViewer;
